// extracted by mini-css-extract-plugin
export var ctaLink = "multiMediaGrid-module--ctaLink--99c07";
export var gridContainer = "multiMediaGrid-module--gridContainer--864db";
export var gridItem = "multiMediaGrid-module--gridItem--8919e";
export var gridItemQuote = "multiMediaGrid-module--gridItemQuote--93d67";
export var multiMediaGrid = "multiMediaGrid-module--multiMediaGrid--319bf";
export var quoteSource = "multiMediaGrid-module--quoteSource--1c993";
export var quoteText = "multiMediaGrid-module--quoteText--6e9ed";
export var textBlockParagraph = "multiMediaGrid-module--textBlockParagraph--ed6f7";